import request from './request'

//Para cada módulo crear un archivo con las requests necesarias, para exportarlas y llamarlas desde el componente correspondiente

export function getAllLicitadores(){
    return request({
        url:'/licitadores/all',
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getDetallesLicitador(id){
    return request({
        url:'licitadores/id/'+id,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function crearLicitador(licitador){
    return request({
        url:'licitadores',
        method:'POST',
        data: licitador,
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}